var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayerIconCmu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_849_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5366 0.5H19.7974C9.25134 0.5 0.666992 9.08435 0.666992 19.6304V61.3696C0.666992 71.9157 9.25134 80.5 19.7974 80.5H61.5366C72.0826 80.5 80.667 71.9157 80.667 61.3696V19.6304C80.667 9.08435 72.0826 0.5 61.5366 0.5ZM77.1887 61.3696C77.1887 70.0026 70.1696 77.0217 61.5366 77.0217H19.7974C11.1644 77.0217 4.14525 70.0026 4.14525 61.3696V19.6304C4.14525 10.9974 11.1644 3.97826 19.7974 3.97826H61.5366C70.1696 3.97826 77.1887 10.9974 77.1887 19.6304V61.3696Z",
    fill: "url(#paint0_linear_849_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6324 53.0079C51.1822 53.0079 59.7628 44.4273 59.7628 33.8775C59.7628 23.3277 51.1822 14.7471 40.6324 14.7471C30.0826 14.7471 21.502 23.3277 21.502 33.8775C21.502 44.4273 30.0826 53.0079 40.6324 53.0079ZM40.6324 18.4833C49.1157 18.4833 56.0191 25.3867 56.0191 33.87C56.0191 42.3533 49.1157 49.2567 40.6324 49.2567C32.1491 49.2567 25.2457 42.3533 25.2457 33.87C25.2457 25.3867 32.1491 18.4833 40.6324 18.4833Z",
    fill: "url(#paint1_linear_849_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6177 41.1556L48.0444 35.7122C49.4595 34.8961 49.4595 32.8595 48.0444 32.0434L38.6177 26.6C37.2026 25.7839 35.4355 26.8022 35.4355 28.4344V39.3212C35.4355 40.9535 37.2026 41.9717 38.6177 41.1556Z",
    fill: "url(#paint2_linear_849_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8181 61.2447H59.9851C59.4285 59.6864 57.9468 58.5664 56.2007 58.5664C54.4546 58.5664 52.9659 59.6864 52.4164 61.2447H13.5155C12.5555 61.2447 11.7764 62.0238 11.7764 62.9838C11.7764 63.9438 12.5555 64.7229 13.5155 64.7229H52.792C53.5016 65.8568 54.7607 66.6151 56.2007 66.6151C57.6407 66.6151 58.8929 65.8568 59.6094 64.7229H67.8181C68.7781 64.7229 69.5572 63.9438 69.5572 62.9838C69.5572 62.0238 68.7781 61.2447 67.8181 61.2447Z",
    fill: "url(#paint3_linear_849_15)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_849_15",
    x: 0.666992,
    y: 0.5,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_849_15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_849_15",
    x1: 40.667,
    y1: 0.5,
    x2: 40.667,
    y2: 80.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_849_15",
    x1: 40.6324,
    y1: 14.7471,
    x2: 40.6324,
    y2: 53.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_849_15",
    x1: 42.2707,
    y1: 26.3125,
    x2: 42.2707,
    y2: 41.4431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_849_15",
    x1: 40.6668,
    y1: 58.5664,
    x2: 40.6668,
    y2: 66.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerIconCmu);
export default __webpack_public_path__ + "static/media/player_icon_cmu.6ee93cf1891983b4ac19d61dbd8dfbe9.svg";
export { ForwardRef as ReactComponent };